import { useUnit } from 'effector-react'
import { Fragment, memo, type JSX } from 'react'
import { LoadMoreRowsTrigger } from './load-more-rows-trigger'
import { dynamicModuleModel } from '~/widgets/DynamicModule'
import { Row } from './row'

const INSERT_TRIGGER_N_ITEMS_BEFORE = 2

export const DynamicRows = memo(DynamicRows_)
function DynamicRows_(): JSX.Element {
  const [rows, isLoaded] = useUnit([
    dynamicModuleModel.$viewRows,
    dynamicModuleModel.$isRowsLoaded,
  ])

  return (
    <>
      {rows.map((row, i) => {
        const shouldInsertTrigger =
          !isLoaded &&
          rows.length > INSERT_TRIGGER_N_ITEMS_BEFORE &&
          i + 1 === rows.length - INSERT_TRIGGER_N_ITEMS_BEFORE

        return (
          <Fragment key={row.id}>
            <Row id={row.id} />
            {shouldInsertTrigger && <LoadMoreRowsTrigger />}
          </Fragment>
        )
      })}
    </>
  )
}
